module.exports = __webpack_public_path__ + "img/rainy-7.c915395f.svg";